@if (userService?.user) {
    <nav class="navbar navbar-expand-lg navbar-dark fixed-top">
        <div class="d-block d-md-none menu-button btn" (click)="menuOpen = !menuOpen">
            <i class="fa fa-fw fa-2x" [class.fa-bars]="!menuOpen" [class.fa-xmark]="menuOpen"></i>
        </div>
        <a class="navbar-brand d-flex align-items-center py-1 ms-3" routerLink="/">
            <img src="/assets/logo-large.png" class="py-1" alt="Tiwi Land Council" />
        </a>
        <ul class="d-flex flex-grow-1 menu m-0 p-0 mr-3 d-none d-md-flex" [class.open]="menuOpen" (click)="menuOpen = false" style="justify-content: end">
            <li>
                <a routerLink="/account/" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">Account</a>
            </li>
            <ng-container>
                <li>
                    <a routerLink="/account/invoices" routerLinkActive="active-link">Invoices</a>
                </li>
            </ng-container>
            <li class="cart p-0" routerLinkActive="active-cart">
                <a routerLink="/account/cart" class="ps-lg-3 pe-lg-3 ps-1 pe-1"
                    ><i class="fa fa-shopping-basket me-0 me-lg-2"></i> <span class="d-none d-lg-inline">Cart</span></a
                >
            </li>
        </ul>
        <ul class="d-flex flex-grow-1 menu m-0 p-0 d-md-none" [class.open]="menuOpen" (click)="menuOpen = false">
            <li>
                <a routerLink="/account/" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">Account</a>
            </li>
            <li>
                <a routerLink="/account/invoices" routerLinkActive="active-link">Invoices</a>
            </li>
            <li class="cart" routerLinkActive="active-cart">
                <a routerLink="/account/cart"><i class="fa fa-shopping-basket me-2"></i> Cart</a>
            </li>
        </ul>
        @if (userService.watch | async; as _user) {
            @if (_user.loggedIn) {
                <div class="ms-auto" ngbDropdown display="dynamic" placement="bottom-end">
                    @if (_user.loggedIn) {
                        <button class="btn profile-button" id="userDropdownMenu" ngbDropdownToggle (click)="update()">
                            <!--<a class="notification" routerLink="user-admin/notifications" (click)="$event.stopPropagation()">-->
                            <!--    <ngxh6-notification-badge [outline]="true"></ngxh6-notification-badge>-->
                            <!--</a>-->
                            <ngxh6-usericon
                                [user]="_user.account.user.name ? _user.account.user : { fullName: '&#9733;' }"
                                [showTooltip]="false"
                                class="me-0"
                            ></ngxh6-usericon>
                        </button>
                    }
                    <div ngbDropdownMenu aria-labelledby="userDropdownMenu">
                        <h6 class="dropdown-header">{{ _user.account.user.name }}</h6>
                        @if (!_user.account.impersonating) {
                            <button class="dropdown-item danger" (click)="userService.logOut()"><i class="fa fa-fw fa-sign-out me-2"></i> Logout</button>
                        }
                        @if (_user.account.impersonating) {
                            <button class="dropdown-item danger" (click)="userService.exitImpersonation()">
                                <i class="fa fa-fw fa-sign-out me-2"></i> Exit Impersonation
                            </button>
                        }
                        <div class="dropdown-divider"></div>
                        <h6 class="dropdown-header">Theme</h6>
                        @for (theme of themeService.themesKeys; track theme) {
                            <button class="dropdown-item theme-selector" (click)="themeService.setTheme(theme)">
                                <i
                                    class="fa fa-fw me-2 fa-regular"
                                    [class.fa-square-check]="theme === themeService.currentTheme"
                                    [class.fa-square]="theme !== themeService.currentTheme"
                                ></i>
                                {{ themeService.themes[theme] }}
                            </button>
                        }
                        <!--<div class="dropdown-divider"></div>-->
                        <!--<div class="dropdown-divider"></div>-->
                        <!--<h6 class="dropdown-header">App Version {{ version }}</h6>-->
                        <!--<h6 class="dropdown-header">Environment: {{ env }}</h6>-->
                    </div>
                </div>
            }
        }
    </nav>
}
